import BrandWorkflows from './BrandWorkflows.Container';

export default BrandWorkflows;
